import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { ITaskV2ChecklistDataBase } from '@fi-app/task-v2/fi-task-v2';
import { IMediaBankFileReference } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-task-v2-automated-description',
    templateUrl: './fi-task-v2-automated-description.component.html',
    styleUrls: ['./fi-task-v2-automated-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-automated-description' },
    standalone: false,
})
export class FiTaskV2AutomatedDescriptionComponent {
    @Input({ required: true }) checklistData: ITaskV2ChecklistDataBase;
    @Input() taskDescription: string;
    @Input() taskMediaBankFileReferences: IMediaBankFileReference[];
    @Input() rowLayout: boolean = false;
    @Input() unlimitedAttachmentSize: boolean = false;

    @ViewChild('checklistDescriptionEl', { static: false }) checklistDescriptionEl: ElementRef<HTMLElement>;
    @ViewChild('additionalTaskDescriptionEl', { static: false }) additionalTaskDescriptionEl: ElementRef<HTMLElement>;
}
